export default function HiddenToolFields() {
	return (
		<>
			<input
				type="hidden"
				id="_wpnonce"
				name="_wpnonce"
				value={window?.wpObject?.nonce}
			/>

			<input
				type="hidden"
				id="cok_tool_id"
				name="cok_tool_id"
				value={window?.wpObject?.cok_tool_id}
			/>
		</>)
	;
}
